__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-11-1773223125-stable-dev/";